import { TypeOfCancer } from '@/components/icons/icon-catch/types';
import { SourceQuote } from '../testing-plan/components/test-details/types';

export enum InterventionCategoryIcon {
  fruits = 'Diet-Fruits-&-Veggies',
  grains = 'Diet-Whole Grains',
  meat = 'Diet-Meat & Fish',
  dairy = 'Diet-Dairy',
  dietGeneral = 'Diet-General',
  beverages = 'Diet-Beverages',
  coffee = 'Diet-Coffee',
  cardio = 'Excercise-Cardio',
  strength = 'Excercise-Strength',
  exerciseGeneral = 'Exercise-General',
  labwork = 'Clinical-Labwork',
  scans = 'Clinical-Scans',
  drVisit = 'Clinical-Dr',
  shots = 'Clinical-Shots',
  skin = 'Misc-Skin',
  sun = 'Misc-Sun',
  weight = 'Misc-Weight',
  smoking = 'Misc-Smokin',
  supplements = 'Misc-Supplements',
  environmental = 'Misc-Environmental',
  home = 'Misc-Home',
}

export enum TypeOfBlock {
  Paragraph = 'paragraph',
  Bullet = 'bullet',
}

export type Paragraph = {
  type: 'paragraph';
  content: string;
};

export type BulletPoints = {
  type: 'bullet';
  items: string[];
};

export type WhyItMatters = Paragraph | BulletPoints;

export type RiskImpact = {
  cancerType: TypeOfCancer | 'overall';
  impact: number;
};

export enum InterventionType {
  ALL = 'All',
  DIET = 'Diet',
  LIFESTYLE = 'Lifestyle',
  OTHER = 'Other',
}

export enum InterventionStatus {
  IN_PROGRESS = 'IN_PROGRESS',
  COMPLETED = 'COMPLETED',
  AVAILABLE = 'AVAILABLE',
}

export type Intervention = {
  id: string;
  status: InterventionStatus;
  interventionType: InterventionType;
  title: string;
  category: InterventionCategoryIcon;
  whyItMattersShortExplanation: string;
  whyItMattersFullExplanation: string;
  completedAt: string;
  riskImpactDescription: string;
  copyWhenCompleted: string;
  riskImpact: RiskImpact[];
  overallRiskImpact: number;
  howToAccomplish: string;
  sources: Array<SourceQuote>;
  questionId: string;
  assignedAt: string;
  isNonQuantifiable: boolean;
};

export type GroupedInterventions = {
  [key: string]: Intervention[];
};
